import {Config} from "./config"; // Import Config if needed
import {showToast} from "./toast"; // Import the showToast function

export function initializeFormSubmission() {
    const saveTriggerButtons = document.querySelectorAll('.save-trigger-button');
    const forms = document.querySelectorAll('.ambikly-form');

    saveTriggerButtons.forEach(button => {
        button.addEventListener('click', () => {
            forms.forEach(form => form.dispatchEvent(new Event('submit', {cancelable: true})));
        });
    });

    forms.forEach((formElement) => {
        formElement.addEventListener('submit', (e: Event) => {
            e.preventDefault();
            const form = e.currentTarget as HTMLFormElement;

            // Check if the form is valid
            if (!form.checkValidity()) {
                form.reportValidity(); // Show validation messages
                return; // Stop submission
            }

            const formData = new FormData(form);
            disableSubmitButtons(); // Disable buttons and show saving text

            fetch(Config.AJAX_URL ?? '', {
                method: 'POST',
                body: formData,
            })
                .then((response) => response.json())
                .then((response) => {
                    enableSubmitButtons(); // Re-enable buttons

                    // Clear any previous error messages
                    const errorMessages = document.querySelectorAll('.form-group .error-message');
                    errorMessages.forEach(errorMessage => errorMessage.remove());

                    if (response === 0) {
                        showToast('An error occurred. Please check your AJAX function name or server response.', 'error');
                        return;
                    }

                    if (response.success) {
                        showToast(response.data.message, 'success');
                    } else {
                        showToast(response.data.message, 'error');
                        displayValidationErrors(response.data.validationErrors);
                    }
                    if (response.data.redirect && response.data.redirect !== '') {
                        setTimeout(() => {
                            window.location.href = response.data.redirect;
                        }, 1000); // Redirect after 3 seconds
                    }
                })
                .catch((error) => {
                    enableSubmitButtons(); // Re-enable buttons
                    showToast('Something went wrong. Please try again.', 'error');
                });
        });
    });
}

// Disable buttons during submission
function disableSubmitButtons() {
    const saveTriggerButtons = document.querySelectorAll('.save-trigger-button');
    const submitButtons = document.querySelectorAll('button[type="submit"]');

    saveTriggerButtons.forEach(button => {
        const savingText = button.getAttribute('data-saving-text') || 'Saving...'; // Get data-saving-text or use default
        button.setAttribute('disabled', 'true');
        button.textContent = savingText;
        button.innerHTML += ' <i class="loading-spinner"></i>'; // Add spinner
    });

    submitButtons.forEach(button => {
        const savingText = button.getAttribute('data-saving-text') || 'Saving...'; // Get data-saving-text or use default
        button.setAttribute('disabled', 'true');
        button.textContent = savingText;
        button.innerHTML += ' <i class="loading-spinner"></i>'; // Add spinner
    });
}

// Enable buttons after submission
function enableSubmitButtons() {
    const saveTriggerButtons = document.querySelectorAll('.save-trigger-button');
    const submitButtons = document.querySelectorAll('button[type="submit"]');

    saveTriggerButtons.forEach(button => {
        const saveText = button.getAttribute('data-text') || 'Save'; // Get data-text or use default 'Save'
        button.removeAttribute('disabled');
        button.textContent = saveText;
    });

    submitButtons.forEach(button => {
        const saveText = button.getAttribute('data-text') || 'Save'; // Get data-text or use default 'Save'
        button.removeAttribute('disabled');
        button.textContent = saveText;
    });
}

// Display validation errors
function displayValidationErrors(validationErrors: { [key: string]: string[] }) {
    Object.entries(validationErrors).forEach(([fieldName, errors]) => {
        const errorMessage = errors.join(', ');
        const fieldGroup = document.querySelector(`[name="${fieldName}"]`)?.closest('.form-group');

        if (fieldGroup) {
            const existingErrorMessage = fieldGroup.querySelector('.error-message');
            if (existingErrorMessage) existingErrorMessage.remove(); // Remove existing message

            const errorElement = document.createElement('p');
            errorElement.className = 'error-message';
            errorElement.style.color = 'red';
            errorElement.textContent = errorMessage;

            const label = fieldGroup.querySelector('label');
            if (label) {
                label.insertAdjacentElement('afterend', errorElement);
            }
        }
    });
}
